/*
$(document).on('click','.despliega-menu',function(){
    $(".menu-nav").toggle();
});
*/
document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('menuToggle');
    const menu = document.querySelector('.menu-nav');
    if(toggle && menu) {
        toggle.addEventListener('click', function () {
            toggle.classList.toggle('open');
            menu.classList.toggle('visible');
        });
        document.addEventListener('click', function (e) {
            const isClickInsideMenu = menu.contains(e.target);
            const isClickOnToggle = toggle.contains(e.target);
    
            if (!isClickInsideMenu && !isClickOnToggle) {
                menu.classList.remove('visible');
                toggle.classList.remove('open');
            }
        });
    }
});